import { Group } from "@mantine/core"
import { OperationsAdminVenueAreaTabs } from "src/components/operations/administrator/areas/OperationsAdminVenueAreaTabs"
import { EditOperationsAdminVenueAreaAction } from "src/components/operations/administrator/areas/OperationsAdminVenueAreaActions"
import { useAppState } from "src/state"
import { DrawerPageLayout } from "src/components/ui/DrawerPageLayout"
import { DrawerPageHeader } from "src/components/ui/DrawerPageHeader"
import { OperationsAdminVenueAreaView } from "src/components/operations/administrator/areas/OperationsAdminVenueAreaView"

export const OperationsAdminVenueAreaOverlay = () => {

    const { currentItem } = useAppState(state => state.areas)

    return (
        <DrawerPageLayout
            header={
                <DrawerPageHeader
                    title={`${currentItem?.name}`}
                    renderAction={
                        <Group gap="sm">
                            <EditOperationsAdminVenueAreaAction />
                        </Group>
                    }
                />
            }
        >
            <OperationsAdminVenueAreaTabs overlay/>
            <OperationsAdminVenueAreaView/>
        </DrawerPageLayout>
    )

}